import useBindActionCreators from 'common/hooks/useBindActionCreators';

import { countriesOperations } from '../store';

type CountriesOperations = typeof countriesOperations;

export const useCountriesOperations = (): CountriesOperations => {
  return useBindActionCreators<CountriesOperations>(countriesOperations);
};
